<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> نمودار {{ title }}
    <v-spacer>
    </v-spacer>
      <chart-export-btn :page-chart-id="chart_id"></chart-export-btn>
      <v-tooltip right v-if="summary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" :href="`/report/${report_type}ChartReport`">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده کامل
      </v-tooltip>

    </v-card-title>
    <canvas height="110" :id="chart_id"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'buyChart',
  components: {ChartExportBtn},
  props: {
    summary: {
      default: false,
    },
    report_type: {
      default: 'buy',
    },
  },

  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "",
              data: [],
              backgroundColor: "rgba(1, 158, 246, .3)",
              borderColor: "#019EF6",
              borderWidth: 3,
              hoverBorderWidth:5
            },
            {
              label: " ",
              data: [],
              borderColor: "#F1416C",
              backgroundColor: "rgba(241, 65, 108, .3)",
              borderWidth: 3,
              hoverBorderWidth:5
            },
            {
              label: " ",
              data: [],
              borderColor: "#50CD89",
              backgroundColor: "rgba(80, 205, 136, .3)",
              borderWidth: 3,
              hoverBorderWidth:5
            },
            {
              label: "",
              data: [],
              borderColor: "#FFC700",
              backgroundColor: "rgba(255, 199, 0, .3)",
              borderWidth: 3,
              hoverBorderWidth:5
            }
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },

          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .10)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }

                }
              }
            ]
          }
        }
      },
    }
  },
  methods : {
    setChartStyle(){
      if (this.report_type == 'sale') {
        this.setSaleChartColors()
      }
      this.chartData.data.datasets[0].label = `${this.title}  ناخالص`
      this.chartData.data.datasets[1].label = `برگشت از ${this.title} ناخالص`
      this.chartData.data.datasets[2].label = 'تخفیفات خالص'
      this.chartData.data.datasets[3].label = `${this.title} خالص`
    },

    setSaleChartColors(){
      this.chartData.data.datasets[0].backgroundColor = 'rgba(67, 206, 215, .3)'
      this.chartData.data.datasets[0].borderColor = '#43CED7'
      this.chartData.data.datasets[1].backgroundColor = 'rgba(241, 65, 108, .3)'
      this.chartData.data.datasets[1].borderColor = '#F1416C'
      this.chartData.data.datasets[2].backgroundColor = 'rgba(255, 199, 0, .3)'
      this.chartData.data.datasets[2].borderColor = '#FFC700'
      this.chartData.data.datasets[3].backgroundColor = 'rgba(186, 10, 255, .3)'
      this.chartData.data.datasets[3].borderColor = '#ba0aff'
    },

    getSummaryChartFromApi(){
      this.request({
        url: this.endpoint(`reports/buySaleSum?type=${this.report_type}`),
        method: "get",
        success: data => {
          console.log(data)
          this.getSummaryData(data)
        }
      })
    },

    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/BuySaleSumByMonth?type=${this.report_type}`),
        method: "get",
        success: data => {
          console.log(data)
          this.getData(data.results)
        }
      })
    },

    getSummaryData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = ['جمع کل']
      this.chartData.data.datasets[0].data = [data.all.amount_sum]
      this.chartData.data.datasets[1].data = [data.all.back_from]
      this.chartData.data.datasets[2].data = [data.all.discount]
      this.chartData.data.datasets[3].data = [data.all.amount]

      this.getChart()
    },
    getData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[1].data = []
      this.chartData.data.datasets[2].data = []
      this.chartData.data.datasets[3].data = []

      for (let month of data){
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.amount_sum)
        this.chartData.data.datasets[1].data.push(month.back_from)
        this.chartData.data.datasets[2].data.push(month.discount)
        this.chartData.data.datasets[3].data.push(month.amount)

      }

      this.getChart()
    },
    getChart(){
      this.setChartStyle(this.report_type)
      const ctx = document.getElementById(`${this.chart_id}`);
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    if (this.summary) {
      this.getSummaryChartFromApi()
    }else {
      this.getChartFromApi()
    }
  },
  computed: {
    chart_id() {
      if (this.report_type == 'buy') {
        return 'buy-chart'
      } else {
        return 'sale-chart'
      }
    },
    title() {
      if (this.report_type == 'buy') {
        return 'خرید'
      } else {
        return 'فروش'
      }
    },
  },

}
</script>